<style lang="stylus">

    .credit-modal
        position absolute
        top 0
        left 0
        display flex
        justify-content center
        align-items center
        width 100vw
        height 100vh

        .credit-mask
            modal-mask()

        .credit-box
            position relative
            width 432px
            background #FFFFFF
            box-shadow 0px 15px 30px rgba(0, 0, 0, 0.2)
            border-radius 8px
            z-index 1000
            .credit-loadding
                position absolute
                left 0
                top 0
                display flex
                justify-content center
                align-items center
                width 100%
                height 100%
                background rgba(0,0,0,.4)

                img
                    width 30%
                    height 30%

            .credit-title
                font-size 16px
                line-height 16px
                color #232323
                text-align center

            .credit-btn
                height 32px
                border-radius 72px
                padding 0 24px
                font-size 14px
                line-height 32px
                text-align center
                color #fff
                user-select none
                cursor pointer
                transition all .2s linear
                background #017fff

                &:hover
                    background #117deb

            .user-wallet
                p
                    text-align center
                    font-size 14px
                    color #232323
                    margin-bottom 12px
                div
                    width 100%
                    height 48px
                    padding 16px
                    display flex
                    justify-content center
                    align-items center
                    border 1px solid rgba(64, 64, 64, 0.1)
                    border-radius 4px
                    font-size 20px
                    color #232323

            .credit-head
                display flex
                justify-content flex-end
                height 24px
                margin-top 8px
                width 100%

                img
                    width 24px
                    height 24px
                    cursor pointer
                    margin-right 8px

            .credit-paytype
                .paytype-list
                    width 376px
                    margin 26px auto 0 auto
                    display flex
                    justify-content space-between

                    .paytype-item
                        width 120px
                        height 120px
                        border 2px solid transparent
                        cursor pointer
                        border-radius 4px
                        img
                            width 116px
                            height 116px

                        &.active
                            border-color #017fff

                .paytype-btn-box
                    display flex
                    margin 30px 0
                    width 100%
                    justify-content center

            .credit-use
                padding 0 32px 32px 32px
                .use-bigprice
                    margin 32px auto 32px auto

                    p
                        font-weight 500
                        font-size 48px
                        line-height 64px
                        color #232323
                        text-align center

                .use-walletbox
                    display flex
                    flex-wrap wrap
                    justify-content center
                    margin-bottom 32px

                    >p
                        font-size 14px
                        line-height 16px
                        color #232323
                        margin-bottom 8px

                        span
                            color #787878

                    .use-wallet
                        width 100%
                        height 48px
                        padding 16px
                        display flex
                        justify-content space-between
                        align-items center
                        border 1px solid rgba(64, 64, 64, 0.1)
                        border-radius 4px
                        cursor pointer

                        p
                            font-size 20px
                            color #232323
                            font-weight 700

                        svg
                            stroke #f0f0f0

                            &.active
                                stroke #017fff

                .use-paybox
                    display flex
                    justify-content space-between
                    align-items center

                    .returntext
                        font-size 14px
                        line-height 16px
                        color #017fff
                        cursor pointer
                        user-select none
            .credit-succ
                margin-top 17px
                padding 0 32px 32px 32px

                .succ-btnbox
                    display flex
                    justify-content center
                    margin-top 20px
                    width 100%

                .succ-usepage
                    margin-top 20px
                    margin-bottom 38px
                    font-size 14px
                    line-height 16px
                    color #232323
                    text-align center

                    span
                        color #017fff
                        cursor pointer

            .credit-fail
                margin-top 32px
                padding 0 32px 32px 32px

                .fail-img
                    display block
                    width 44px
                    height 44px
                    margin 0 auto
                    margin-bottom 18px

                .fail-wallet
                    margin-top 32px
</style>

<template>
    <div class="credit-modal" v-if="showCredit">
        <div class="credit-mask" :class="{ noMask: isPC }" @click="closeModal"></div>
        <div class="credit-box">
            <div class="credit-head">
                <img src="@/home/parts/credit/assets/close.svg" @click="closeModal" draggable="false" @dragstart.prevent alt="" />
            </div>
            <div class="credit-loadding" v-if="showLoading">
                <img :src="require('@/home/assets/img/logoanimation.gif')" alt="" />
            </div>
            <div class="credit-paytype" v-if="boxType == 0">
                <p class="credit-title">{{ $t("paytype") }}</p>
                <div class="paytype-list">
                    <div class="paytype-item" :class="{ active: selectPayType == 0 }" @click="selectPayType = 0">
                        <img src="@/home/parts/credit/assets/type1.svg" />
                    </div>
                    <div class="paytype-item" :class="{ active: selectPayType == 1 }" @click="selectPayType = 1">
                        <img src="@/home/parts/credit/assets/type2.svg" />
                    </div>
                    <div class="paytype-item" :class="{ active: selectPayType == 2 }" @click="selectPayType = 2">
                        <img src="@/home/parts/credit/assets/type3.svg" />
                    </div>
                </div>
                <div class="paytype-btn-box">
                    <div class="credit-btn" @click="toPay">{{ $t("topay") }}</div>
                </div>
            </div>
            <div class="credit-use" v-else-if="boxType == 1">
                <p class="credit-title">{{ activeUseTitle }}</p>
                <div class="use-bigprice">
                    <p>{{ activePrice }}</p>
                </div>
                <div class="use-walletbox">
                    <p>
                        {{ $t("balance") }}
                        <span>{{ $t("balance-tip") }}</span>
                    </p>
                    <div class="use-wallet" @click="isSelectWallet = true">
                        <p>{{ activeMoney }}</p>
                        <svg
                            :class="{ active: isSelectWallet }"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="inherit"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                stroke="inherit"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path d="M7.5 12L11 15.5L16.5 9.5" stroke="inherit" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
                <div class="use-paybox">
                    <p class="returntext" @click="returnToQR">{{ $t("returnText") }}</p>
                    <div class="credit-btn" @click="confirm">{{ $t("confirm") }}</div>
                </div>
            </div>
            <div class="credit-succ" v-else-if="boxType == 2">
                <p class="credit-title">{{ $t("successTitle") }}</p>
                <div class="succ-btnbox" v-if="!isPC">
                    <div class="credit-btn" @click="toUse">{{ $t("toUse") }}</div>
                </div>
                <p class="succ-usepage">
                    {{ $t("userPagePrev") }}
                    <span @click="toUserPage">{{ $t("userPage") }}</span>
                    {{ $t("userPageSuff") }}
                </p>
                <div class="user-wallet">
                    <p>{{ $t("balance") }}</p>
                    <div>{{ activeMoney }}</div>
                </div>
            </div>
            <div class="credit-fail" v-else-if="boxType == 3">
                <img class="fail-img" src="@/home/parts/credit/assets/error.svg" alt="" />
                <p class="credit-title">{{ $t("failTitle") }}</p>
                <div class="user-wallet fail-wallet">
                    <p>{{ $t("balance") }}</p>
                    <div>{{ activeMoney }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class Credit extends Vue {
        boxType = 1;
        selectPayType = 0;
        workPrice = 0;
        isSelectWallet = false;
        userMoney = 0;
        showLoading = false;
        clonedObj = null;

        get showCredit() {
            return this.$store.state.tplCenter.showCredit;
        }
        set showCredit(v) {
            this.$store.commit("toTplCenter", {
                name: "showCredit",
                data: v,
            });
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get activeUseTitle() {
            return this.$t("useTitlePrev").toString() + this.activePrice + this.$t("useTitleSuff").toString();
        }
        get activePrice() {
            return "" + this.workPrice + this.$t("priceUnit");
        }
        get activeMoney() {
            return "" + this.userMoney + this.$t("priceUnit");
        }
        get work() {
            return this.$store.state.tplCenter.activeWork;
        }
        get boughtWorks() {
            return this.$store.state.tplCenter.boughtWorks;
        }
        get mapUrl() {
            if (~location.href.indexOf("/online/")) {
                return "/online/app.html";
            } else {
                return "/app.html";
            }
        }
        startLoading() {
            this.showLoading = true;
        }

        endLoading() {
            this.showLoading = false;
        }

        closeModal() {
            this.showCredit = false;
            this.boxType = 1;
            this.isSelectWallet = false;
            this.selectPayType = 0;
        }

        toPay() {
            if (this.selectPayType < 2) {
                // wx alipay
                this.closeModal();
                this.$bus.$emit("updatePayPanelStatus", {
                    showPay: true,
                    cloneSucess: false,
                    clonedObj: "",
                });
            } else {
                // 抵用金
                this.startLoading();
                this.initStatus().then(() => {
                    this.boxType = 1;
                    this.endLoading();
                });
            }
        }

        returnToQR() {
            this.boxType = 0;
            this.closeModal();
            this.$bus.$emit("updatePayPanelStatus", {
                showPay: true,
                cloneSucess: false,
                clonedObj: "",
            });
        }

        confirm() {
            console.log("confirm to pay");
            if (!this.isSelectWallet) {
                // 未勾选抵用金
                let text = this.$t("noSelect").toString();
                this.$edMessage.warning({ content: text });
                return;
            }
            this.startLoading();
            let success = () => {
                this.boxType = 2;
                this.endLoading();
            };
            let fail = () => {
                this.boxType = 3;
                this.endLoading();
            };
            this.useCredit(success, fail);
        }

        cloneData() {
            let tempWork = null;
            for (let item of this.boughtWorks) {
                if (item.work_id == this.work.id) {
                    tempWork = item;
                    break;
                }
            }
            if (tempWork) {
                if (this.work.type == "edt") {
                    // 符号模板
                    return Promise.resolve();
                }
                if (this.isPC) {
                    let win: any = window;
                    let { sign, exp, path } = tempWork;
                    let callPcAction = (sign, exp, path, imgUrl) => {
                        sign = encodeURIComponent(sign);
                        let param = {
                            id: tempWork.work_id,
                            track: tempWork.work_id + "",
                            fileName: this.work.title,
                            sign,
                            exp,
                            obj: path,
                            type: "clone",
                            imgUrl,
                            accessid: this.OSSAccessKeyId,
                        };
                        win.$qt.jsCallCloudFileOperate(JSON.stringify(param));
                    };
                    let imgUrl = tempWork.url ? `${window["GLOBAL"].PUBLIC_OSS_HOST + tempWork.url}thumb.png` : "noImage";
                    callPcAction(sign, exp, path, imgUrl);
                    return Promise.resolve();
                } else {
                    //把作品克隆到自己的云里
                    let limitCallback = (type = "") => {
                        if (type == "showLimitCloudSpaceVIP") {
                            if (this.fuser) {
                                this.$bus.$emit("showCloudSpaceVipTips");
                            } else {
                                this.$checkAuth({
                                    type: "cloudSpaceVIP",
                                    buyTrigger: "cloudSpacePop",
                                    pcParams: { newUpgrade: 6, upgrade: 0 },
                                });
                            }
                        } else if (type == "showLimitCloudSpace") {
                            this.$checkAuth({
                                type: "cloudSpace",
                                buyTrigger: "cloudSpacePop",
                                pcParams: { newUpgrade: 6, upgrade: 0 },
                            });
                        } else {
                            this.$store.commit("toPublicStatus", {
                                type: "showUpgrade",
                                data: "fileNum",
                            });
                        }
                    };
                    let enterCanvasTrack = `&file_source=templateFile&template_type=communityPaid&diagram_type=others`;
                    return this.$openFile({
                        params: {
                            id: this.userInfo.user_id,
                            workId: tempWork.work_id,
                            token: this.userInfo.token,
                        },
                        fileType: "paidTemplate",
                        suffix: enterCanvasTrack,
                        checkLimit: false,
                        limitRange: "web",
                        limitCallback: limitCallback,
                        vip: this.vip,
                        isFullCouldSpace: this.isFullCouldSpace,
                    })
                        .then((obj) => {
                            this.clonedObj = obj.obj;
                        })
                        .catch((err) => {
                            if (err.msg == "noSpace") {
                                this.$store.commit("toPublicShow", {
                                    type: "upgrade",
                                    data: "noSpace",
                                });
                            }
                        });
                }
            }
            return Promise.reject();
        }
        toUse() {
            if (this.work.type == "edt") {
                this.$bus.$emit("paySymbolCallback", "success");
            } else {
                let ts: any = this;
                let winName = this.clonedObj,
                    href = window.location.origin + this.mapUrl + "?" + ts.$zipFileName("obj=" + winName),
                    winref;
                if (this.openInTabs) {
                    location.href = href;
                } else {
                    winref = window.open(href, winName);
                }
                if (winref.location.href === "about:blank") {
                    winref.location.href = href;
                }
                // add open record
                this.$store.commit("addWin", winref);
                let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
                if (!openTabs.includes(winName)) {
                    openTabs.push(winName);
                }
                localStorage.setItem("openTabs", JSON.stringify(openTabs));

                let query = location.search && new URLSearchParams(location.search.slice(1));
                if (query && query.has("noClone")) return;

                this.$bus.$emit("closePreview");
                this.addTemplateRecent(this.work.id);
            }
            this.closeModal();
        }

        toUserPage() {
            this.closeModal();
            let id = this.userInfo.user_id;
            if (this.isPC && this.internal) {
                this.$store.commit("toVisitUser", {
                    id,
                });
                this.$store.commit("toTplCenter", {
                    name: "showUserWorks",
                    data: true,
                });
                this.$store.commit("userPage/clickUserWordId", id);
            } else {
                let path = this.internal ? "templates/user" : "templates/users";
                let href = `${window.location.origin}/${path}/${id}`;
                if (this.isPC) {
                    (<any>window).$qt.jsCallOpenUrl(href);
                } else {
                    window.open(href);
                }
            }
            console.log("to user page");
        }

        initStatus() {
            let p = [];
            this.workPrice = parseFloat(this.work.price);
            p.push(this.getCredit());
            return Promise.all(p);
        }
        getCredit() {
            // 获取抵用金余额
            this.$edApi
                .getCredit({
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                })
                .then((res) => {
                    console.log(res);
                    let data = res.data.data;
                    this.userMoney = data && parseFloat(data.surplus);
                });
        }
        useCredit(success, fail) {
            return this.$edApi
                .useCredit({
                    user_id: this.userInfo.user_id,
                    token: this.userInfo.token,
                    work_id: this.work.id,
                    category: "max-work",
                })
                .then((res) => {
                    console.log(res);
                    if (res.data.status == "success") {
                        // 成功
                        this.$store.dispatch("getBoughtWorks").then(() => {
                            this.cloneData()
                                .then(() => {
                                    success && success();
                                })
                                .catch((e) => {
                                    fail && fail();
                                });
                        });
                        this.userMoney = res.data.data && parseFloat(res.data.data.surplus);
                    } else {
                        // 失败
                        fail && fail();
                    }
                });
        }
        addTemplateRecent(id) {
            if (!this.$validateLogin()) return;
            this.$edApi.addTemplateHistory({
                user_id: this.userInfo.user_id,
                token: this.userInfo.token,
                data: {
                    template_id: id,
                    template_from: "COMMUNITY",
                },
            });
        }

        @Watch("showCredit")
        watchCredit(nv) {
            if (nv) {
                this.initStatus();
            }
        }

        created() {}
        mounted() {}
    }
</script>
<i18n>
{
  "zh": {
    "paytype": "请选择支付方式",
    "topay": "支付",
    "useTitlePrev": "本次模板将会使用您",
    "useTitleSuff": "模板抵用金",
    "priceUnit": "元",
    "balance": "您的社区模板抵用金余额",
    "balance-tip": "(*购买模板后不支持退款)",
    "returnText": "返回使用微信/支付宝扫码支付",
    "confirm": "确认支付",
    "successTitle": "恭喜您，支付成功！",
    "toUse": "立即使用",
    "userPagePrev": "您也可以在社区",
    "userPage": "个人主页",
    "userPageSuff": "中查看购买模板哦~",
    "failTitle": "很遗憾，支付失败",
    "noSelect": "请选择抵用金",
    "": ""
  },
  "en": {
    "paytype": "Choose your way to pay",
    "topay": "Confirm",
    "useTitlePrev": "This Template will cost",
    "useTitleSuff": " ",
    "priceUnit": "￥",
    "balance": "Your Credit",
    "balance-tip": "（*Not Refundable）",
    "returnText": "Back",
    "confirm": "Confirm",
    "successTitle": "Congradulation",
    "toUse": "To Use",
    "userPagePrev": "You can check your bought template on ",
    "userPage": "personal center",
    "userPageSuff": ".",
    "failTitle": "Sorry, Fail to Pay",
    "noSelect": "Please select your template credit"
  },
  "fr": {},
  "de": {},
  "jp": {},
  "es": {},
  "pt": {},
  "it": {},
  "tw": {},
  "kr": {},
  "id": {
    "paytype": "Pilih cara membayar",
    "topay": "Konfirmasi",
    "useTitlePrev": "Templat ini akan dikenakan biaya",
    "useTitleSuff": " ",
    "priceUnit": "￥",
    "balance": "Kredit Anda",
    "balance-tip": "（*Dana Tidak Dapat Dikembalikan）",
    "returnText": "Kembali",
    "confirm": "Konfirmasi",
    "successTitle": "Selamat",
    "toUse": "Yang akan Digunakan",
    "userPagePrev": "Anda dapat memeriksa templat yang Anda beli di ",
    "userPage": "pusat personal",
    "userPageSuff": ".",
    "failTitle": "Maaf, Gagal Membayar",
    "noSelect": "Pilih kredit templat Anda"
  }
}
</i18n>
